import React, { useState} from 'react'
import { Button, IconButton, Fab, Container } from '@material-ui/core'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import { useHistory } from 'react-router-dom';
import {useDropzone} from 'react-dropzone';
import { PhotoCamera } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ItemModel from './model/item';

import { useFirestoreConnect } from 'react-redux-firebase';
import { useSelector } from 'react-redux';
import AddChilds from './childsModal/AddChilds';
import SaveIcon from '@material-ui/icons/Save';
import {useDispatch} from 'react-redux'
import { AddItem, UpdateItem } from '../../redux/actions/item/ItemAction';


const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    root: {
        '& > *': {
          margin: theme.spacing(1),
          width: '40ch',
        },
      },
    formstyle:{
        margin:'0 auto',
        width:'max-content',
    }
}));

// const values = [
//   {value: 'Fournisseur1', label: 'Fournisseur1'},
//   {value: 'Fournisseur2', label: 'Fournisseur2'},
// ]


export const CommandeForm = ({MItem=new ItemModel(), ActionType, onChange}) => {

  //#region states

  const classes = useStyles();
  const dispatch = useDispatch()
  const [files, setFiles]= useState([]);
  // const [sousCat, setSousCat]= useState()
  const [Item, setItem] = useState(MItem)
  const [openChildsModal, setOpenChildsModal] = useState(false);

  // const [Error, setError] = useState({})

  //#endregion
  
  //#region firestoreConnector
      useFirestoreConnect(()=>[
        {collection:"categories", storeAs:"cat"}
      ])
  //#endregion

  //#region selector 
  //     const cat = useSelector(state=> state.firestore.ordered["cat"])
      const loading = useSelector(state=>state.item.isLoading)
  //#endregion

  const navigation = useHistory();

//#region functions Image
// const handleClose = () => {
//   setOpen(false);
// };

const handleBack = () => {
  navigation.goBack();
};



const {getRootProps, getInputProps} = useDropzone({
  accept : "image/*",
  onDrop : (acceptedFiles)=>{
      setFiles(
              acceptedFiles.map((f)=> Object.assign(f, {
              preview : URL.createObjectURL(f)
          }))
      );
  }
  
})

//#endregion
 
//#region GESTION ERROR 
  // const handleError=(ExecuteAction)=>{

  // }
//#endregion

//#region SUBMIT
  const navBack =()=>{
    navigation.goBack();
  }

  const handleSubmitItem=(e)=>{
      e.preventDefault()
      if(ActionType ==="Create"){
        if(files !== null && files.length > 0){
          Item.Price = parseInt(Item.Price)
          dispatch(AddItem(Item, navBack, files[0]))
        }else{
          dispatch(AddItem(Item, navBack))
        }
       
      }else if(ActionType ==="Update"){
        if(files !== null && files.length > 0){
          Item.Price = parseInt(Item.Price)
          dispatch(UpdateItem(Item, navBack, files[0]))
        }else{
          dispatch(UpdateItem(Item, navBack))
        }
      }
  }


  // const handleSubmitUpdateItem=()=>{
      
  // }

  // const handleClearform=()=>{

  // }
//#endregion


    const images = files.map(f=> (
        <Container key={f.name}> 
            <img src={f.preview}  style={{width:"300px",height:"300px"}} alt={f.name} />
        </Container>
    ))

    return (
        <div>
            <AddChilds open={openChildsModal}  setOpen={setOpenChildsModal} setItem={setItem} />

            <Button style={{backgroundColor:"black", color:"white"}} onClick={handleBack} startIcon={<KeyboardBackspaceIcon/>}>
                retour
            </Button>           

          {loading &&(
            <Backdrop className={classes.backdrop} open={true} >
                <CircularProgress />
            </Backdrop>)
          }

            <form  className={classes.formstyle}>
                <div style={{float:"left"}}> 
                    {/* <div className={classes.root}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel htmlFor="category">Fournisseur</InputLabel>
                            <Select
                              native
                              value={Item.Categorie ? Item.Categorie : ""}
                              onChange={(e)=>{
                                let idx = e.target.selectedIndex;
                                let dataset = e.target.options[idx].dataset;
                                let val = JSON.parse(dataset.isd);
                                setItem({...Item, Categorie : val.categoryName})
                                setSousCat(val.subCategory)
                              }}
                              
                              label="Categorie"
                              inputProps={{
                                name: 'Categorie',
                                id: 'category',
                              }}
                              
                            >
                              <option aria-label="None" value="" />
                              {
                                cat && cat[0]?.category.map((ca, i)=>(
                                  <option key={i} data-isd={JSON.stringify(ca)} value={ca.categoryName}>{ca.categoryName}</option>
                                ))
                              }
                            </Select>
                        </FormControl>

                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel htmlFor="sousCategorie">Sous Categorie</InputLabel>
                            <Select

                              native
                              value={Item?.sousCategorie}
                              onChange={(e)=>{setItem({...Item, sousCategorie: e.currentTarget.value})}}
                              label="Sous Categorie"
                              inputProps={{
                                name: 'Sous Categorie',
                                id: 'sousCategorie',
                              }}
                            >
                              <option aria-label="None" value="" />
                              {
                                sousCat && sousCat.map((sc, i)=>(
                                  <option key={i} value={sc.subCat}>{sc.subCat}</option>
                                ))
                              }
                            </Select>
                        </FormControl>
                        
                    </div> */}

                    {/* <div className={classes.root}>
                        <TextField  required label="Code Barre"
                                    value={Item.Barcode} 
                                    InputLabelProps= {{shrink : true}}
                                    onChange={(e)=>setItem({...Item, Barcode: e.currentTarget.value})}
                                    variant="outlined" />
                        <TextField label="Prosoft-Reference"
                                    value={Item.InternalId}
                                    InputLabelProps= {{shrink : true}}
                                     onChange={(e)=>setItem({...Item, InternalId: e.currentTarget.value})}
                                    variant="outlined" />
                    </div> */}

                    <div className={classes.root}>
                        <TextField  required label="Nom du Produit"
                                      value={Item.Name}
                                      InputLabelProps= {{shrink : true}}
                                     onChange={(e)=>setItem({...Item, Name: e.currentTarget.value})}
                                     variant="outlined" />
                        <TextField  required label="Prix de Vente"
                                    value={Item.Price}
                                    InputLabelProps= {{shrink : true}}
                                    type="number"
                                     onChange={(e)=>setItem({...Item, Price: e.currentTarget.value})}
                                    variant="outlined" />
                    </div>
                    <div className={classes.root}>
                    {/* <InputLabel htmlFor="category">Fournisseur</InputLabel>
                      <Select
                        onChange={value => onChange && onChange(value.value)}
                        defaultValue={values[1]}
                        options={values}
                      /> */}
                      <TextField  required label="Prix d' achat"
                                    value={Item.Price}
                                    InputLabelProps= {{shrink : true}}
                                    type="number"
                                     onChange={(e)=>setItem({...Item, Price: e.currentTarget.value})}
                                    variant="outlined" />
                    </div>

                    {/* <div className={classes.root}>
                       <TextField  required label="Seuil d'alerte"
                                    value={Item.Threshold}
                                    type="number"
                                    InputLabelProps= {{shrink : true}}
                                    onChange={(e)=>setItem({...Item, Threshold: parseInt(e.currentTarget.value)})}
                                    variant="outlined" /> 

                          <FormControlLabel
                            control={
                            <Checkbox
                                name="checkedB"
                                checked={Item.IsExpirationDateRequire}
                                value={Item.IsExpirationDateRequire}
                                color="primary"
                                onChange={(e)=>setItem({...Item, IsExpirationDateRequire : e.currentTarget.checked})}
                            />
                            }
                            label="Produit Périssable"
                        />
                    </div> */}
                                       
                    <div className={classes.root}>
                        <TextField  label="Stock Dekon"
                                    value={Item.Stock?.Dekon}
                                    InputLabelProps={{
                                      shrink : true
                                    }} 
                                    onChange={(e)=>setItem({...Item, Stock: {Cassablanca : Item.Stock.Cassablanca,  Dekon: Math.max(e.currentTarget.value, 0)} })}
                                    variant="outlined" type="number" />
                        <TextField  required label="Stock Cassablanca"
                                     InputLabelProps={{
                                      shrink : true
                                    }} 
                                    value={Item.Stock?.Cassablanca}
                                     onChange={(e)=>setItem({...Item, Stock: {Cassablanca: Math.max(e.currentTarget.value, 0)}, Dekon : Item.Stock.Dekon })}
                                    variant="outlined"  type="number" />
                    </div>

                    {/* <div className={classes.root}>
                      

                        <FormControlLabel
                            control={
                              <Checkbox
                              name="checkedB"
                              value={Item.HasChilds}
                              checked={Item.HasChilds}
                              color="primary"
                              onChange={(e)=>{
                                setItem({...Item, HasChilds : e.currentTarget.checked})
                                // setOpenChildsModal(e.currentTarget.checked)
                              }}
                              />
                            }
                            label="Est un Paquet"
                        />

                            <FormControlLabel
                                    control={
                                      
                                    <Checkbox
                                    value={Item.IsProductValidated}
                                    checked={Item.IsProductValidated}
                                        name="checkedB"
                                        color="primary"
                                        onChange={(e)=>setItem({...Item, IsProductValidated : e.currentTarget.checked})}
                                    />
                                    }
                                    label="Produit Validé"
                                />                       
                    </div> 
                     <div>
                    <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        label="Description"
                        multiline
                        rows={4}
                        variant="outlined"
                        />
                    </div> */}

                    <div className={classes.root} style={{marginTop:20}}>
                            {/* <Button startIcon={<ClearIcon/>} style={{backgroundColor:"red", color:"white"}}
                                    onClick={()=>{}} >
                              Vider
                            </Button> */}

                            <Button startIcon={<SaveIcon/>} style={{backgroundColor:"green", color:"white"}}
                                    type="submit" onClick={handleSubmitItem}>
                              Envoyer
                            </Button>
                    </div>

                </div>
                       
                {/* UPLOAD IMAGE WITH DRAG AND DROP OPTION */}
                <div style={{width:"300px", height:"300px", float:"left",}}>
                    {/* Input entry */}
                    <div {...getRootProps()} >   
                        <input {...getInputProps()} />
                        <p style={{margin:"0 auto", padding:0, marginTop:"20px",width:"max-content"}}>Glissez-déposez </p>
                        <div style={{margin:"0 auto", padding:0, width:"max-content", marginRight:50}}>
                                <label htmlFor="contained-button-file">
                                    <Button variant="contained" color="primary" component="span">
                                    AJOUTER IMAGE
                                    </Button>
                                </label>
                                <label htmlFor="icon-button-file">
                                    <IconButton color="primary" aria-label="upload picture" component="span">
                                    <PhotoCamera />
                                    </IconButton>
                                </label>
                        </div>
                    </div>       
                        {
                            files.length > 0 &&
                        <Fab color="secondary" style={{float:"right", marginTop:-50, }}
                            aria-label="Supprimer" onClick={()=> setFiles([])}>
                            <ClearIcon />
                        </Fab>
                        }
                    {/* Imgae div */}
                    <Container >
                        {
                         ( files.length < 1) ? <img src={Item.ImageUrl} alt={Item.Name}  style={{width:"300px",height:"300px"}} /> 
                          :
                           images
                        }
                    </Container>
                </div>
                
            </form>
        </div>
    )
}


    function CircularProgressWithLabel(props) {
        return (
          <Box position="relative" display="inline-flex">
            <CircularProgress color="inherit" size={100} thickness={10} variant="determinate" {...props} />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="bold"
              fontSize={20}
            >
              <Typography variant="caption" component="div" style={{fontWeight:'bold', fontSize:20}} color="textSecondary">{`${Math.round(
                props.value,
              )}%`}</Typography>
            </Box>
          </Box>
        );
    }

  CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
  };

